const LocationIcon = ({color = "#FF3B30"}) => {
  return (
    <svg
      width="34"
      height="40"
      viewBox="0 0 34 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6667 0C12.2479 0.00485266 8.01147 1.76236 4.88691 4.88691C1.76236 8.01147 0.00485266 12.2479 0 16.6667C0 25.47 14 37.555 15.59 38.905L16.6667 39.815L17.7433 38.905C19.3333 37.555 33.3333 25.47 33.3333 16.6667C33.3285 12.2479 31.571 8.01147 28.4464 4.88691C25.3219 1.76236 21.0855 0.00485266 16.6667 0ZM16.6667 25C15.0185 25 13.4073 24.5113 12.0369 23.5956C10.6665 22.6799 9.5984 21.3784 8.96767 19.8557C8.33694 18.333 8.17191 16.6574 8.49346 15.0409C8.815 13.4244 9.60867 11.9395 10.7741 10.7741C11.9395 9.60867 13.4244 8.815 15.0409 8.49346C16.6574 8.17191 18.333 8.33694 19.8557 8.96767C21.3784 9.5984 22.6799 10.6665 23.5956 12.0369C24.5113 13.4073 25 15.0185 25 16.6667C24.9974 18.876 24.1185 20.9941 22.5563 22.5563C20.9941 24.1185 18.876 24.9974 16.6667 25Z"
        fill={color}
      />
    </svg>
  );
};

export default LocationIcon;
